import React from "react";
import ReactApexChart from "react-apexcharts";

class BasicRadarChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.radarChartData,
      chartOptions: this.props.radarChartOptions,
    });
  }

  render() {
    return (
      <ReactApexChart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="bar"
      />
    );
  }
}

export default BasicRadarChart;